import { DateInput } from "components/inputs";
import React from "react";
import { BooleanInput, Filter, TextInput, useListContext, useTranslate } from "react-admin";

import { ToggleTitleInput } from "../../../components/filters/ToggleInputs";
import { CompanySelect } from "../../../components/inputs";
import { SelectEnumInput } from "../../../components/inputs/SelectEnumInput";
import {
	ChargeTypeByCode,
	CodeByChargeType,
	CustomerServiceChargeType,
} from "../../../entities/CustomerCDChargeType";
import { useAsOfDateMode } from "./AsOfDateModeContext";

const AsOfDateFilters = ({ canFilterByCompany, onToggle }) => {
	const translate = useTranslate();

	return (
		<Filter>
			<ToggleTitleInput
				source="is_as_of_date_mode"
				value={true}
				label0={translate("resources.customer-articles.filters.as_of_date_mode")}
				label1={translate("resources.customer-articles.filters.close_as_of_date_mode")}
				alwaysOn
				cb={onToggle}
			/>

			<DateInput
				source="as_of_date"
				label={translate("resources.customer-articles.filters.as_of_date")}
				alwaysOn
				style={{ minWidth: 150 }}
			/>

			{canFilterByCompany && <CompanySelect allowEmpty alwaysOn style={{ minWidth: 200 }} />}
		</Filter>
	);
};

const StandardFilters = ({ isAdmin, canFilterByCompany, onToggle }) => {
	const translate = useTranslate();

	return (
		<Filter>
			{isAdmin && (
				<ToggleTitleInput
					source="is_as_of_date_mode"
					value={true}
					label0={translate("resources.customer-articles.filters.as_of_date_mode")}
					label1={translate("resources.customer-articles.filters.close_as_of_date_mode")}
					alwaysOn
					cb={onToggle}
				/>
			)}

			{canFilterByCompany && <CompanySelect allowEmpty alwaysOn style={{ minWidth: 200 }} />}

			{canFilterByCompany && (
				<TextInput source="company_accountancy_number" alwaysOn style={{ minWidth: 200 }} />
			)}

			<SelectEnumInput
				source="article_code:in"
				label="resources.customer-articles.fields.charge_type"
				enumObj={CustomerServiceChargeType}
				enumName="cs_service_charge_type"
				parse={(value) => CodeByChargeType[value]}
				format={(value) => value && ChargeTypeByCode[value[0]]}
				allowEmpty
				alwaysOn
				style={{ minWidth: 150 }}
			/>

			<DateInput source="created_at:gte" alwaysOn style={{ minWidth: 150 }} />
			<DateInput source="created_at:lte" alwaysOn style={{ minWidth: 150 }} />
			<BooleanInput source="is_t1" alwaysOn />
		</Filter>
	);
};

export const CustomerArticlesListFilters = ({ isAdmin, canFilterByCompany }) => {
	const { setFilters } = useListContext();
	const { isAsOfDateMode, setIsAsOfDateMode } = useAsOfDateMode();

	const handleToggleAsOfDateMode = React.useCallback(
		(newValue) => {
			setIsAsOfDateMode(newValue);
			if (newValue) {
				setFilters({
					is_as_of_date_mode: true,
					no_range: true,
				});
			} else {
				setFilters({});
			}
		},
		[setFilters, setIsAsOfDateMode]
	);

	if (isAsOfDateMode) {
		return (
			<AsOfDateFilters
				canFilterByCompany={canFilterByCompany}
				onToggle={handleToggleAsOfDateMode}
			/>
		);
	}

	return (
		<StandardFilters
			isAdmin={isAdmin}
			canFilterByCompany={canFilterByCompany}
			onToggle={handleToggleAsOfDateMode}
		/>
	);
};
